import { ColumnDef } from "@tanstack/react-table";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import Badge from "components/base/Badge";
import { format } from "date-fns";
import { Link } from "react-router-dom";

export type VersaoTableType = {
  id: number;
  tag: string;
  createdAt: string;
  descricao: string;
  instalador?: boolean;
};

export const versaoTableColumns: ColumnDef<VersaoTableType>[] = [
  {
    accessorKey: "id",
    header: "ID",
    meta: {
      headerProps: { style: { width: 100 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "tag",
    header: "Tag",
    cell: ({ row: { original } }) => {
      const { tag, id } = original;
      return (
        <Link to={`/admin/versoes/${id}`} className="fw-semibold">
          {tag}
        </Link>
      );
    },
    meta: {
      headerProps: { style: { width: 150 }, className: "ps-4" },
      cellProps: { className: "ps-4" },
    },
  },
  {
    accessorKey: "createdAt",
    header: "Data",
    cell: ({ row: { original } }) => {
      const date = new Date(original.createdAt);
      return format(date, 'dd/MM/yyyy HH:mm');
    },
    meta: {
      headerProps: { style: { width: 200 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "descricao",
    header: "Descrição",
    cell: ({ row: { original } }) => {
      return <div className="line-clamp-3">{original.descricao}</div>;
    },
    meta: {
      headerProps: { style: { width: 350 }, className: "ps-4" },
      cellProps: { className: "ps-4" },
    },
  },
  {
    accessorKey: "instalador",
    header: "Instalador",
    cell: ({ row: { original } }) => {
      return original.instalador ? (
        <Badge variant="tag">Instalador</Badge>
      ) : (
        <></>
      );
    },
    meta: {
      headerProps: { style: { width: 120 }, className: "ps-4 text-center" },
      cellProps: { className: "ps-4 text-center" },
    },
  },
];

const VersaoTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default VersaoTable;
